<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="text-center">
        <p v-if="data.exported" class="text-danger">
          <strong>This invoice (ID {{ data.id }}) has been exported to QuickBooks.</strong>
        </p>
        <p v-else>
          You are about to delete invoice ID {{ data.id }}.
        </p>

        <p>
          Are you sure you want to delete it? This action cannot be undone.
        </p>
      </div>

      <input type="hidden" name="_method" value="DELETE">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Cancel</button>
      <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete Invoice</button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Confirmation dialog to claim invoice deletion.
   *
   * Input properties:
   *
   * modalId  - custom id for modal component.
   * action   - form action URL.
   * title    - form title.
   * id       - invoice ID for deletion.
   * exported - has invoice been exported to QB?
   *
   * Usage examples:
   *
   * <delete-invoice-modal action="..." modal-id="...">
   * </delete-invoice-modal>
   *
   * Trigger example:
   *
   * <button type="button" title="Delete invoice" v-modal="'deleteInvoiceModal'">
   * <i class="fa fa-trash"></i></button>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'deleteInvoiceModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: "Delete Invoice"
    },

    // Invoice ID for deletion.
    id: {
      type: Number,
      default: 0
    },

    // Has invoice been exported to QB?
    exported: {
      type: Boolean,
      default: false
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        id: this.id,
        exported: this.exported
      },
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  },
}
</script>
